// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
interface Props {
  strokeColor?: string;
  size?: number;
}

const IconMinusCircle = ({ strokeColor = '#24252A', size = 16 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="6" stroke={strokeColor} strokeWidth="1.5" />
      <path
        d="M5 8H11"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default IconMinusCircle;
